import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Box, Card, CardContent, CardActionArea, TextField, styled, } from '@mui/material';
import Checkbox from '../../atoms/Checkbox';
import { Caption, H5 } from '../../atoms/typography';
import ItemAlertBorder from '../../atoms/ItemAlertBorder';
import ImageWithZoom from '../../molecules/ImageWithZoom';
import { toKebabCase } from '../../../utils';
import { Alert } from '../../atoms/Alert';
const ContentNoPadding = styled(CardContent) `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  gap: 16px;
  &:last-child {
    padding-bottom: 0;
  }
`;
const StyledTextField = styled(TextField) `
  input {
    padding: 0 0 1px;
  }
  & .MuiInput-root::before, .MuiInput-root::after {
    content: none;
  }
`;
const TRANSLATE_PREFERENCES = {
    default: { label: 'yes', value: 'no' },
    parentSku: { label: 'no', value: 'no' },
    details: { label: 'yes', value: 'yes' },
};
const ItemCard = ({ alt = undefined, className = '', displayIconAlertBorder = false, hasActions = false, // make state later?
imageUrl = undefined, alertInfo = undefined, itemProperties, itemTitle = 'Product', variant = 'normal', onClick, }) => {
    const cardRef = useRef(null);
    const [cardHeight, setCardHeight] = useState(0);
    const [isMissing, setIsMissing] = useState(false);
    const [hasPhotoError, setHasPhotoError] = useState(false);
    useEffect(() => {
        if (cardRef.current) {
            const height = cardRef.current.clientHeight;
            setCardHeight(height);
        }
    }, []);
    const handlePhotoError = () => {
        setHasPhotoError(true);
    };
    const itemPropertiesDisplay = itemProperties.filter(itemProperty => itemProperty.value);
    const { title, details, severity = 'info' } = alertInfo || {};
    return (_jsxs(Box, { className: className, sx: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '1.5rem',
            width: 'max-content',
            alignItems: 'normal',
        }, children: [alertInfo &&
                _jsx(Alert, { title: title, severity: severity, children: details }), _jsxs(Card, { sx: {
                    display: 'flex',
                    width: 'max-content',
                    position: 'relative',
                }, ref: cardRef, children: [(imageUrl && !hasPhotoError) &&
                        _jsx(ImageWithZoom, { imageUrl: imageUrl, alt: alt, onError: handlePhotoError, size: {
                                image: variant === 'small' ? '198px' : `${cardHeight.toString()}px`,
                            }, maxZoomWidth: 'lg', isZoomable: variant === 'normal', clickImageToZoom: variant === 'normal', maxWidth: '600px' }), _jsxs(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            width: '488px',
                            maxWidth: '488px',
                            p: 1.5,
                        }, onClick: onClick ?? undefined, children: [_jsxs(ContentNoPadding, { children: [_jsx(H5, { children: itemTitle }), itemPropertiesDisplay.map((property) => {
                                        const translationPreference = TRANSLATE_PREFERENCES[property.key] ?? TRANSLATE_PREFERENCES.default;
                                        return (property.key !== 'details' ?
                                            _jsx(StyledTextField, { translate: translationPreference.label, className: "styled", id: `${toKebabCase(property.label)}-input`, variant: 'standard', label: property.label, defaultValue: property.value, InputProps: {
                                                    readOnly: true,
                                                    translate: translationPreference.value,
                                                } }, property.label) :
                                            _jsxs(Box, { translate: translationPreference.value, children: [_jsx(Caption, { color: 'text.secondary', translate: translationPreference.label, children: property.label }), property.value] }, 'item-details'));
                                    })] }), hasActions &&
                                _jsx(CardActionArea, { children: _jsx(Checkbox, { label: 'missing', name: 'missing-checkbox', checked: isMissing, onChange: (e) => setIsMissing(e.target.checked) }) })] }), displayIconAlertBorder &&
                        _jsx(ItemAlertBorder, { variant: 'flag' })] })] }));
};
export default ItemCard;
//# sourceMappingURL=index.js.map